import { FamilyHome } from "../FamilyHome.jsx";

function HistoryFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        History you play, not history you memorize
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        The problem with most history learning tools: they treat history
        as a list of dates to memorize. The dates are the result of
        history, not history itself. History is decisions made under
        constraint, with imperfect information, by people who didn't
        know how it would turn out. NerdHistory games hand you the
        constraints and let you make the decisions. The dates get
        absorbed along the way, but the point is the pressure — what
        does it actually feel like to govern a province, or stand at
        a council, or balance a treasury that won't last the winter?
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What's here
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Roman Province — you're a Roman provincial governor in
        Antonine Aquitania, AD 142. Five resources to manage; events
        that compound; decisions that have consequences a few turns
        later. Survive your term or don't. Picks up where the actual
        textbooks leave off — at the edge of what was easy and into
        what was real.
      </p>

      <p style={{ margin: "0 0 16px", color: "#7C8099", fontStyle: "italic" }}>
        More provinces and historical scenarios are on the roadmap.
        Britannia, Egypt, and Asia Minor each have their own shapes.
      </p>
    </>
  );
}

export default function HistoryHome() {
  return <FamilyHome familyId="history" seoContent={<HistoryFamilySeo />} />;
}
